import React, { Component, push } from "react";
import { withRouter } from "react-router-dom";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  //Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Layer,
  Tip,
  Spinner,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Console,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Close,
  Rewind,
  FormLock,
  View,
  Hide,
  SubtractCircle,
} from "grommet-icons";
//import { SingleSelect } from "react-select-material-ui";
import { hpe as theme } from "grommet-theme-hpe";
import Alert from "@material-ui/lab/Alert";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import auth from "./Security/Auth";
import {
  callApiGetJson,
  callApiPostJson,
  OnDemandRefreshInterval,
  logAccess,
  callApiGetJsonwithEP,
} from "./GlobalSettings";
import Launchdemospinner from "./Launchdemospinner";
import InfoWarning from "./InfoWarning";

class ScheduleDemoOverlayB extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // eventTypeData: undefined,
      // demoEvtTypeVal: "Select Event Type",
      // isEvtListDisabled: true,
      // EvtTypeSelected: undefined,
      newEventRequestVM: this.props.evtReqVM,
      DemoData: this.props.demo,
      showAvailableSeatLoader: false,
      eventTMECRSeats: undefined,
      houstonSelectedCount: 0,
      sgpSelectedCount: 0,
      bristolSelectedCount: 0,
      OppID: undefined,
      TMECRDescription: undefined,
      TMECR_SeatPwd: undefined,
      CustomerName: undefined,
      NoOppIDChecked: false,
      showSFDCValidating: false,
      errorInValidation: false,
      stickMessage: undefined,
      NoOppIDReason: undefined,
      UserInfo: auth.getUserInfo(),
      bShowEvtCreationOnDemandLoader: false,
      bTriggerActiveDemosCall: false,
      bShowDupeEvtOverlay: false,
      SubmitLabel: "Validate Opp ID",
      message: undefined,
      isErrOnSubmit: false,
      isFrndlyPwdStrong: true,
      revealPwd: false,
      selectedHstSeatNames: new Array(),
      selectBriSeatNames: new Array(),
      selectedSgpSeatNames: new Array(),
    };

    //this.loadEventTypes = this.loadEventTypes.bind(this);
    //this.handleDemoEventTypeChange = this.handleDemoEventTypeChange.bind(this);
    // this._handleEventRequestOnDemand =
    //   this._handleEventRequestOnDemand.bind(this);
    this.handleOppID = this.handleOppID.bind(this);
    this.handleCustomerName = this.handleCustomerName.bind(this);
    this.handleTMECRDescription = this.handleTMECRDescription.bind(this);
    this.handleTMECRFrndlyPwd = this.handleTMECRFrndlyPwd.bind(this);
    this.setOppIDChecked = this.setOppIDChecked.bind(this);
    this._onSFDCOpptyIdSubmit = this._onSFDCOpptyIdSubmit.bind(this);
    this._handleHoustonSeatCount = this._handleHoustonSeatCount.bind(this);
    this._handleSgpSeatCount = this._handleSgpSeatCount.bind(this);
    this._handleBristolSeatCount = this._handleBristolSeatCount.bind(this);
    this._HideLauncher = this._HideLauncher.bind(this);
    this._hideInfoWarning = this._hideInfoWarning.bind(this);
    this._handleEventRequestSubmit = this._handleEventRequestSubmit.bind(this);
    this.loadAvailableSeatsForTMECR =
      this.loadAvailableSeatsForTMECR.bind(this);
    this._handleback = this._handleback.bind(this);
    this.setRevealPwd = this.setRevealPwd.bind(this);
    this.handleHOUChangeMultiple = this.handleHOUChangeMultiple.bind(this);
    this.handleBRIChangeMultiple = this.handleBRIChangeMultiple.bind(this);
    this.handleSGPChangeMultiple = this.handleSGPChangeMultiple.bind(this);
  }

  componentDidMount() {
    // this.loadEventTypes();
  }

  setRevealPwd() {
    this.setState({ revealPwd: !this.state.revealPwd });
  }

  handleBRIChangeMultiple(event) {
    /*  const { options } = event.value;
    const value = [];
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    } */
    this.setState({ selectBriSeatNames: event.value });
  }

  handleSGPChangeMultiple(event) {
    /* const { options } = event.value;
    const value = [];
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    } */
    this.setState({ selectedSgpSeatNames: event.value });
  }

  handleHOUChangeMultiple(event) {
    console.log("Houston Seat Multi select hit with value ", event.value);
    /* const { options } = event.value;
    const value = [];
    for (let i = 0, l = event.value.length; i < l; i += 1) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }*/
    this.setState({ selectedHstSeatNames: event.value });
  }

  loadAvailableSeatsForTMECR() {
    this.setState({ showAvailableSeatLoader: true });
    //console.log(date);
    var endpoint = "/Events/TMECRAvailableSeats";
    var postData =
      this.props.timeZoneCR && this.props.is_TMECR
        ? {
            Day: this.props.evtReqVM.Event_StartDate,
            Duration: this.props.evtReqVM.Event_Duration.Duration_ID,
            PhysicalContentID: this.props.demo.Content_ID,
            evtTimezone: this.props.timeZoneCR,
          }
        : {
            Day: this.props.evtReqVM.Event_StartDate,
            Duration: this.props.evtReqVM.Event_Duration.Duration_ID,
            PhysicalContentID: this.props.demo.Content_ID,
            evtTimezone: null,
          };
    let token = auth.getToken();

    console.log("Before TmeCRSeats Call req Payload is ", postData);
    callApiPostJson(endpoint, postData, token).then((data) => {
      console.log("TME_CR_AvailableSeats data:" + data);
      if (data !== undefined) {
        this.setState({
          eventTMECRSeats: data,
          showAvailableSeatLoader: false,
        });
      }
    });

    //this just refreshes the user token if necessary
    // auth.verifyToken(true);
  }

  _handleback() {
    this.props.hideback();
  }

  _handleEventRequestSubmit() {
    let token = auth.getToken();
    var endpoint = "/Events/AddEventModified";

    // Here to put further execution under customewr name and with eiher nooppid resaon or oppid

    var EvtVM = this.props.evtReqVM;

    var phyCont = {
      Phy_ID: this.props.demo.Content_ID,
      Phy_Description: this.props.demo.Content_Description,
      Phy_LeadTime: this.props.demo.Content_LeadTime,
      Phy_Status: this.props.demo.Content_Status,
      Phy_Title: this.props.demo.Content_Title,
      Is_MultidayCapable: this.props.demo.Is_MultidayCapable,
    };

    EvtVM.PhysicalContents = phyCont;
    EvtVM.Event_Presenter.EmailAddress =
      this.props.mainPresenter && this.props.is_TMECR
        ? this.props.mainPresenter
        : auth.getUserEmail();
    EvtVM.Event_OpportunityID =
      this.state.OppID &&
      this.state.OppID.length > 1 &&
      this.state.stickMessage &&
      this.state.stickMessage === "Validation Successful"
        ? this.state.OppID
        : null;
    EvtVM.Event_NoOppIDReason = this.state.NoOppIDReason
      ? this.state.NoOppIDReason
      : null;
    EvtVM.Event_CustomerName = this.state.CustomerName
      ? this.state.CustomerName
      : null;
    EvtVM.HoustonSeatCountSelected =
      this.state.selectedHstSeatNames.length > 0 && this.props.is_TMECR
        ? this.state.selectedHstSeatNames
        : null;
    EvtVM.SingaporeSeatCountSelected =
      this.state.selectedSgpSeatNames.length && this.props.is_TMECR
        ? this.state.selectedSgpSeatNames
        : null;
    EvtVM.BristolSeatCountSelected =
      this.state.selectBriSeatNames.length && this.props.is_TMECR
        ? this.state.selectBriSeatNames
        : null;
    EvtVM.Event_TMECR_FriendlyPwd =
      this.state.TMECR_SeatPwd && this.props.is_TMECR
        ? this.state.TMECR_SeatPwd
        : null;
    EvtVM.Event_Description = this.state.TMECRDescription
      ? this.state.TMECRDescription
      : this.props.demo.Content_Title;
    this.setState({
      newEventRequestVM: EvtVM,
      bShowEvtCreationOnDemandLoader: true,
    });

    //this.setState({ bShowEvtCreationOnDemandLoader: true });

    console.log(this.state.newEventRequestVM);
    console.log("submitted - " + endpoint);
    console.log(JSON.stringify(this.state.newEventRequestVM));
    //todo:  implement update or insert

    callApiPostJson(endpoint, this.state.newEventRequestVM, token).then(
      (data) => {
        console.log("Response:");
        //this.setState({ submittingData: false });
        console.log(data);
        if (
          data &&
          data.UpdateMessage &&
          data.UpdateMessage[0].indexOf("Success") > 0 &&
          data.UpdateMessage[0].indexOf("error") < 1
        ) {
          this.setState({
            bShowEvtCreationOnDemandLoader: false,
            bTriggerActiveDemosCall: true,
          });

          logAccess(
            this.props.demo.Content_ID,
            this.props.demo.Content_Type,
            "ScheduleLiveDemo",
            this.props.calledBy,
            auth.getToken()
          );
          /*           if (!this.props.existingEventRecord) {
            logAccess(
              this.props.physicalContentRecord.Phy_ID,
              "Physical",
              "ScheduleLiveDemo",
              this.props.calledBy,
              auth.getToken()
            );
          } */
        } else if (
          data &&
          data.UpdateMessage &&
          data.UpdateMessage[0].indexOf("missing physical environment") > 0
        )
          this.setState({
            message: "Requested Date/Time not available.",
            bShowEvtCreationOnDemandLoader: false,
            isErrOnSubmit: true,
          });
        else if (
          data &&
          data.UpdateMessage &&
          data.UpdateMessage[0].indexOf(
            "email selected does not exist in our system"
          ) > 0
        )
          this.setState({
            message: "Presenter email not found in system",
            bShowEvtCreationOnDemandLoader: false,
            isErrOnSubmit: true,
          });
        else if (data && data.ErrorMessage)
          this.setState({
            message: data.ErrorMessage,
            bShowEvtCreationOnDemandLoader: false,
            isErrOnSubmit: true,
          });
        else
          this.setState({
            message: "Unspecified error saving Event.",
            bShowEvtCreationOnDemandLoader: false,
            isErrOnSubmit: true,
          });
      }
    );
    //this.setState({ disableSubmit: true });
  }

  handleOppID(value) {
    console.log("OPP ID Changed with value ", value);
    if (value.length > 3) {
      this.setState({ SubmitLabel: "Validate Opp ID" });
    }
    this.setState({ OppID: value });
  }

  _hideInfoWarning() {
    this.setState({ bShowDupeEvtOverlay: false });
    this.props.hide();
  }

  /*   _HideLauncher() {
    this.setState({ bTriggerActiveDemosCall: false });
    this.props.hide();
  } */

  setOppIDChecked(value) {
    console.log("NO Opp ID Checkbox value is ", value);
    this.setState({ NoOppIDChecked: value });
    if (value) {
      this.setState({ NoOppIDReason: "I do not have Opp ID" });
      this.setState({
        // NoOppIDReason: "I do not have Opp ID"
        OppID: null,
      });
    } else {
      this.setState({ NoOppIDReason: undefined });
    }
  }

  handleCustomerName(value) {
    console.log("Customer Name with value ", value);
    // var SFDCtoBeShown = true;
    if (this.state.UserInfo.UserAppRoles) {
      var CustOne = this.state.UserInfo.UserAppRoles.find(
        (ar) => ar.AppRoleName === "HPE Customer"
      );
      if (CustOne !== undefined) {
        console.log("Customer App Role Obj is", CustOne);
        this.setState({
          CustomerName: value,
          NoOppIDChecked: true,
          NoOppIDReason: "I do not have Opp ID",
        });
      } else {
        this.setState({ CustomerName: value });
      }
    }
  }

  _handleHoustonSeatCount(value) {
    console.log("HoustonSeat Selected Count ", value);
    var TotalHouston = 0;
    this.state.eventTMECRSeats.map((tmest) => {
      if (tmest.DataCenterName.toLowerCase().indexOf("houston") > 0) {
        TotalHouston = tmest.DCAvailableSeatCount;
      }
    });
    if (String(value).indexOf(".") <= 0) {
      if (value <= TotalHouston) {
        this.setState({ houstonSelectedCount: value });
      } else {
        this.setState({ houstonSelectedCount: TotalHouston });
      }
    } else {
      this.setState({ houstonSelectedCount: 0 });
    }
  }

  _handleSgpSeatCount(value) {
    console.log("Singapore Seat Selected Count ", value);
    var TotalSgp = 0;
    this.state.eventTMECRSeats.map((tmest) => {
      if (tmest.DataCenterName.toLowerCase().indexOf("singapore") > 0) {
        TotalSgp = tmest.DCAvailableSeatCount;
      }
    });
    if (String(value).indexOf(".") <= 0) {
      if (value <= TotalSgp) {
        this.setState({ sgpSelectedCount: value });
      } else {
        this.setState({ sgpSelectedCount: TotalSgp });
      }
    } else {
      this.setState({ sgpSelectedCount: 0 });
    }
  }

  _handleBristolSeatCount(value) {
    console.log("Bristol Seat Selected Count ", value);
    var TotalBristol = 0;
    this.state.eventTMECRSeats.map((tmest) => {
      if (tmest.DataCenterName.toLowerCase().indexOf("bristol") > 0) {
        TotalBristol = tmest.DCAvailableSeatCount;
      }
    });
    if (String(value).indexOf(".") <= 0) {
      if (value <= TotalBristol) {
        this.setState({ bristolSelectedCount: value });
      } else {
        this.setState({ bristolSelectedCount: TotalBristol });
      }
    } else {
      this.setState({ bristolSelectedCount: 0 });
    }
  }

  handleTMECRDescription(value) {
    console.log("TME CR Event Description with value ", value);
    this.setState({ TMECRDescription: value });
  }

  handleTMECRFrndlyPwd(value) {
    console.log(
      "TME CR Event Friendly Password for all selected seats with value ",
      value
    );
    var passw =
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,20}$/;

    if (value.match(passw)) {
      this.setState({ TMECR_SeatPwd: value, isFrndlyPwdStrong: true });
    } else {
      this.setState({ TMECR_SeatPwd: value, isFrndlyPwdStrong: false });
    }
  }

  /* _HPEOnBackClick() {
    this.props.history.push("/"); */

  _onSFDCOpptyIdSubmit() {
    //this.state.oppoIdChecked = true;
    //This will do an fetch to API to validate SFDC ID

    console.log("_onSFDCOpptyIdChange - value: " + this.state.OppID);
    //this.oppoIdChecked = true;
    if (this.state.OppID) {
      if (this.state.OppID.length < 20 && this.state.OppID.length > 2) {
        this.setState({ showSFDCValidating: true });
        //don't call this unless they actually put something in there.
        var endpoint = "/SFDC/GetSFDCValidation?OptyId=" + this.state.OppID;
        let token = auth.getToken();

        callApiGetJson(endpoint, token).then((data) => {
          if (data !== undefined) {
            console.log(data);

            if (data.SRC_OPTY_SHRT_UID != null) {
              var Event_OpportunityID = data.SRC_OPTY_SHRT_UID;
              var EvtVM = this.state.newEventRequestVM;
              EvtVM.Event_OpportunityID = data.SRC_OPTY_SHRT_UID;
              this.setState({
                // Event_OpportunityID: Event_OpportunityID,
                OppID: Event_OpportunityID,
                newEventRequestVM: EvtVM,
                showSFDCValidating: false,
                errorInValidation: false,
                stickMessage: "Validation Successful",
                SubmitLabel: "Validation Successful",
              });
            } else {
              var Event_OpportunityID = undefined;
              this.setState({
                //message: data.Message[0], //keep validating screen up so they see userMessage.
                stickMessage: data.Message[0],
                showSFDCValidating: false,
                OppID: Event_OpportunityID,
                errorInValidation: true,
                SubmitLabel: "Invalid-OPP ID",
                // Event_OpportunityID: Event_OpportunityID,
              });
            }
          } else {
            var Event_OpportunityID = undefined;
            this.setState({
              OppID: Event_OpportunityID,
              showSFDCValidating: false,
              //message: "Error validating SFDC OPP ID.",
              stickMessage: "Error validating SFDC OPP ID.",
              errorInValidation: true,
            });
          }
        });
      }
    }
  }

  _HideLauncher() {
    this.setState({ bTriggerActiveDemosCall: false });
    this.props.hide();
  }

  render() {
    console.log(
      "Props to State from 1st Overlay is EvtReqs ",
      this.state.newEventRequestVM
    );
    console.log(
      "Props to State from 1st Overlay is Demo ",
      this.state.DemoData
    );

    var SFDCtoBeShown = true;
    if (this.state.UserInfo.UserAppRoles) {
      var CustOne = this.state.UserInfo.UserAppRoles.find(
        (ar) => ar.AppRoleName === "HPE Customer"
      );
      if (CustOne !== undefined) {
        console.log("Customer App Role Obj is", CustOne);
        SFDCtoBeShown = false;
      }
    }

    console.log("User Obj is ", this.state.UserInfo);
    console.log("User App Roles are ", this.state.UserInfo.UserAppRoles);
    console.log("SFDCToBeShown flag is", SFDCtoBeShown);

    console.log("selected Houston Seats are ", this.state.selectedHstSeatNames);

    var isPwdStrong = this.state.isFrndlyPwdStrong;

    if (this.state.eventTMECRSeats) {
      console.log("Available TME CR Seats are ", this.state.eventTMECRSeats);
    }

    console.log("Timezone selected is ", this.props.timeZoneCR);
    console.log("Is TME CR Type ", this.props.is_TMECR);

    var HoustonCount = 0;
    var SgpCount = 0;
    var BristolCount = 0;

    var HoustonSeatLst = new Array();
    var BristolSeatLst = new Array();
    var SgpSeatLst = new Array();

    var HoustonSeatNames = new Array();
    var BristolSeatNames = new Array();
    var SgpSeatNames = new Array();

    var HoustonSelectedCount =
      this.state.houstonSelectedCount !== 0
        ? this.state.houstonSelectedCount
        : 0;
    var SgpSelectedCount =
      this.state.sgpSelectedCount !== 0 ? this.state.sgpSelectedCount : 0;
    var BristolSelectedCount =
      this.state.bristolSelectedCount !== 0
        ? this.state.bristolSelectedCount
        : 0;

    var TotalSelectedCount = 0;
    TotalSelectedCount =
      parseInt(
        this.state.selectedHstSeatNames
          ? this.state.selectedHstSeatNames.length
          : 0
      ) +
      parseInt(
        this.state.selectBriSeatNames ? this.state.selectBriSeatNames.length : 0
      ) +
      parseInt(
        this.state.selectedSgpSeatNames
          ? this.state.selectedSgpSeatNames.length
          : 0
      );

    var chakracontent = "";
    var isTME_CR = this.props.is_TMECR ? true : false;
    var TME_CRSeats = this.state.eventTMECRSeats
      ? this.state.eventTMECRSeats
      : null;

    if (this.state.eventTMECRSeats) {
      this.state.eventTMECRSeats.map((tmest) => {
        if (tmest.DataCenterName.toLowerCase().indexOf("houston") > 0) {
          HoustonCount = tmest.DCAvailableSeatCount;
          HoustonSeatLst = tmest.AvailableSeats;
        }
        if (tmest.DataCenterName.toLowerCase().indexOf("singapore") > 0) {
          SgpCount = tmest.DCAvailableSeatCount;
          SgpSeatLst = tmest.AvailableSeats;
        }
        if (tmest.DataCenterName.toLowerCase().indexOf("bristol") > 0) {
          BristolCount = tmest.DCAvailableSeatCount;
          BristolSeatLst = tmest.AvailableSeats;
        }
      });
    }

    console.log("Houston Seat Listing is ", HoustonSeatLst);
    console.log("Bristol Seat Listing is ", BristolSeatLst);
    console.log("Singapore Seat Listing is ", SgpSeatLst);

    HoustonSeatLst.map((hstSt) => {
      HoustonSeatNames.push(hstSt.TMESeat_Name);
    });

    BristolSeatLst.map((briSt) => {
      BristolSeatNames.push(briSt.TMESeat_Name);
    });

    SgpSeatLst.map((sgpSt) => {
      SgpSeatNames.push(sgpSt.TMESeat_Name);
    });

    console.log("Houston Seat Names are ", HoustonSeatNames);
    console.log("Bristol Seat Names are ", BristolSeatNames);
    console.log("Singapore Seat Names are ", SgpSeatNames);

    var bSHowDupeWarning = this.state.bShowDupeEvtOverlay;
    console.log("Duplicate status is ", bSHowDupeWarning);

    var OnDemandLabel = this.state.SubmitLabel;

    if (this.state.showAvailableSeatLoader) {
      chakracontent = (
        <Layer position="center">
          <Box
            align="center"
            direction="row"
            gap="small"
            pad="small"
            key="small"
          >
            <Spinner size="small" />
            <Text size="small">Loading Available TME Classroom Seats...</Text>
          </Box>
        </Layer>
      );
    }

    //var EvtTypeList = undefined;
    //var isEvtTypeDisabled = this.state.isEvtListDisabled;

    var bshowSFDCValidationON = this.state.showSFDCValidating;
    var bIssfdcvalidatrionError = this.state.errorInValidation;
    var sfdcvalidationmsg = this.state.stickMessage;

    var bTriggerLauching = this.state.bTriggerActiveDemosCall;

    /* if (this.state.bTriggerActiveDemosCall) {
      console.log("**** Ya Ya Hippy Hippy Ya Ya Ya");
    } */
    /*     if (this.state.bShowDupeEvtOverlay) {
      console.log("DO NOT TRY TO BE OVER SMART IT IS DUPE");
      alert("Duplicate- Event already running....");
    } */

    var isSubmitNotEnabled = true;
    if (
      this.state.newEventRequestVM.Event_DeliveryLocation &&
      this.state.newEventRequestVM.Event_DeliveryLocation
        .EventDeliveryLocation_ID &&
      this.state.newEventRequestVM.Event_Type &&
      this.state.newEventRequestVM.Event_Type.EventType_ID &&
      this.state.newEventRequestVM.Event_StartDate &&
      this.state.newEventRequestVM.Event_EndDate &&
      this.state.CustomerName &&
      !this.props.is_TMECR
    ) {
      if (
        (this.state.stickMessage === "Validation Successful" ||
          this.state.NoOppIDReason) &&
        !this.state.bShowEvtCreationOnDemandLoader
      ) {
        isSubmitNotEnabled = false;
      }
    }

    if (
      this.state.newEventRequestVM.Event_DeliveryLocation &&
      this.state.newEventRequestVM.Event_DeliveryLocation
        .EventDeliveryLocation_ID &&
      this.state.newEventRequestVM.Event_Type &&
      this.state.newEventRequestVM.Event_Type.EventType_ID &&
      this.state.newEventRequestVM.Event_StartDate &&
      this.state.newEventRequestVM.Event_EndDate &&
      this.state.TMECR_SeatPwd &&
      this.props.is_TMECR
    ) {
      if (
        this.state.selectedHstSeatNames.length +
          this.state.selectBriSeatNames.length +
          this.state.selectedSgpSeatNames.length >
        0
      ) {
        isSubmitNotEnabled = false;
      }
    }

    /* if (
      this.state.newEventRequestVM.Event_DeliveryLocation &&
      this.state.newEventRequestVM.Event_DeliveryLocation
        .EventDeliveryLocation_ID &&
      this.state.newEventRequestVM.Event_Type &&
      this.state.newEventRequestVM.Event_Type.EventType_ID &&
      this.state.newEventRequestVM.Event_StartDate &&
      this.state.newEventRequestVM.Event_EndDate &&
      !SFDCtoBeShown
    ) {
      isSubmitNotEnabled = false;
    } */

    var OppIDValSch =
      this.state.OppID != null || this.state.OppID != undefined
        ? this.state.OppID
        : "";
    console.log("Opportunity ID Text Value is", OppIDValSch);

    return (
      <Main flex="grow" fill="vertical" overflow="auto">
        <Layer animate modal onEsc={this.props.hide}>
          <Box align="center" justify="center">
            <Box
              align="center"
              justify="center"
              background={{ color: "brand" }}
              fill="horizontal"
            >
              <Box
                align="center"
                justify="between"
                direction="row"
                gap="medium"
                fill="horizontal"
              >
                <Heading size="small" level="1" margin="small">
                  Schedule a demonstration contd...
                </Heading>
                <Button icon={<Close />} secondary onClick={this.props.hide} />
              </Box>
              <Text size="xlarge">{this.props.demo.Content_Title}</Text>
            </Box>
            <Box
              align="stretch"
              justify="start"
              direction="column"
              pad="medium"
              gap="medium"
              fill="horizontal"
            >
              {isTME_CR && (
                <Grid>
                  <Text>Classroom Description</Text>
                  <TextInput
                    value={this.state.TMECRDescription}
                    onChange={(event) =>
                      this.handleTMECRDescription(event.target.value)
                    }
                  />
                </Grid>
              )}
              {isTME_CR && (
                <Grid>
                  <Text>Enter Seats Password</Text>
                  <Box
                    align="center"
                    justify="center"
                    direction="row"
                    border={{ style: "ridge" }}
                    elevation="none"
                    round="xsmall"
                  >
                    <TextInput
                      plain
                      type={this.state.revealPwd ? "text" : "password"}
                      value={this.state.TMECR_SeatPwd}
                      // icon={<FormLock size="large" color="brand" />}
                      reverse
                      placeholder="Password for seats"
                      onChange={(event) =>
                        this.handleTMECRFrndlyPwd(event.target.value)
                      }
                    />
                    <Button
                      icon={
                        this.state.revealPwd ? (
                          <View size="medium" />
                        ) : (
                          <Hide size="medium" />
                        )
                      }
                      onClick={this.setRevealPwd}
                    />
                  </Box>
                  {!isPwdStrong && (
                    <Alert severity="error">weak password</Alert>
                  )}
                </Grid>
              )}
              {!isTME_CR && (
                <Grid>
                  <Text>Customer Name</Text>
                  <TextInput
                    value={this.state.CustomerName}
                    onChange={(event) =>
                      this.handleCustomerName(event.target.value)
                    }
                  />
                </Grid>
              )}
            </Box>
            {!isTME_CR && SFDCtoBeShown && (
              <Box
                align="stretch"
                justify="start"
                gap="xsmall"
                fill="horizontal"
                pad={{ left: "medium", top: "small" }}
                direction="row"
                border={{ style: "dashed" }}
              >
                <Grid rows="xxsmall">
                  <Text size="medium">SalesForce OPP Id:</Text>
                  <TextInput
                    // defaultValue="OPE-"
                    placeholder="OPE-xxxxxxxxxx"
                    value={OppIDValSch}
                    onChange={(event) => this.handleOppID(event.target.value)}
                  />
                  <Box
                    align="center"
                    justify="center"
                    hoverIndicator={{ image: "url('')" }}
                    wrap={false}
                  >
                    <Tip
                      plain
                      content={
                        <Box
                          pad="small"
                          gap="small"
                          width={{ max: "small" }}
                          round="small"
                          background="background-front"
                          responsive={false}
                        >
                          <Text weight="bold" color="red">
                            Warning !
                          </Text>
                          <Text size="small">
                            Demo Event without OPP ID may be cancelled, please
                            secure your slot by providing OPP ID
                          </Text>
                        </Box>
                      }
                      dropProps={{ align: { left: "right" } }}
                    >
                      <CheckBox
                        label="I dont have an OPP Id"
                        toggle
                        checked={this.state.NoOppIDChecked}
                        //disabled={this.state.errorInValidation}
                        onChange={(event) =>
                          this.setOppIDChecked(event.target.checked)
                        }
                      />
                    </Tip>
                  </Box>
                </Grid>
                <Box
                  align="start"
                  justify="center"
                  pad="medium"
                  overflow="visible"
                >
                  {/* <Stack fill={false}> */}
                  {!this.state.errorInValidation &&
                  this.state.OppID &&
                  this.state.stickMessage &&
                  this.state.stickMessage === "Validation Successful" ? (
                    <Box
                      align="center"
                      justify="center"
                      pad="xsmall"
                      background={{ color: "brand" }}
                      border={{ color: "white", size: "small" }}
                      round="full"
                    />
                  ) : (
                    <Box
                      align="center"
                      justify="center"
                      pad="xsmall"
                      background={{ color: "red" }}
                      border={{ color: "white", size: "small" }}
                      round="full"
                    />
                  )}
                  <Button
                    label={
                      this.state.showSFDCValidating ? (
                        <Box
                          direction="row"
                          gap="small"
                          justify="center"
                          align="center"
                        >
                          <Spinner size="small" color="brand" />{" "}
                          <Text>Validating..</Text>
                        </Box>
                      ) : (
                        OnDemandLabel
                      )
                    }
                    primary={false}
                    icon={<Validate />}
                    secondary
                    disabled={bshowSFDCValidationON}
                    active={false}
                    hoverIndicator={{ opacity: "medium" }}
                    reverse={false}
                    onClick={this._onSFDCOpptyIdSubmit}
                  />
                  {/* </Stack> */}
                </Box>
              </Box>
            )}
            {chakracontent}
            {isTME_CR && (
              <Box
                align="stretch"
                justify="start"
                direction="column"
                pad="medium"
                gap="none"
                fill="horizontal"
              >
                <Button
                  label="Click to get available seats"
                  primary
                  type="submit"
                  onClick={this.loadAvailableSeatsForTMECR}
                  disabled={this.state.TMECR_SeatPwd && !isPwdStrong}
                />
                <br />
                <Box align="center" justify="between" direction="row">
                  <Text>Number of seats selection for this classroom:</Text>
                  <Box
                    align="center"
                    justify="center"
                    border={{ color: "brand", size: "medium" }}
                    round="full"
                    background={{ color: "brand" }}
                    elevation="small"
                    animation="pulse"
                  >
                    <Text color="white">{TotalSelectedCount}</Text>
                  </Box>
                </Box>
                <Box
                  align="center"
                  justify="between"
                  direction="row"
                  pad="small"
                  gap="large"
                >
                  {HoustonSeatNames.length > 0 && (
                    <Text weight="bold">Houston</Text>
                  )}
                  {BristolSeatNames.length > 0 && (
                    <Text weight="bold">Bristol</Text>
                  )}
                  {SgpSeatNames.length > 0 && (
                    <Text weight="bold">Singapore</Text>
                  )}
                </Box>
                <Box
                  align="stretch"
                  justify="between"
                  direction="row"
                  overflow="scroll"
                >
                  {HoustonSeatNames.length > 0 && (
                    <CheckBoxGroup
                      value={this.state.selectedHstSeatNames}
                      onChange={(event) => {
                        this.handleHOUChangeMultiple(event);
                        //console.log("value: ", event.value);
                        //console.log("option: ", event.option);
                        //setValue(event.value);
                      }}
                      options={HoustonSeatNames}
                    />
                  )}
                  {BristolSeatNames.length > 0 && (
                    <CheckBoxGroup
                      value={this.state.selectBriSeatNames}
                      onChange={(event) => {
                        this.handleBRIChangeMultiple(event);
                        //console.log("value: ", event.value);
                        // console.log("option: ", event.option);
                        //setValue(event.value);
                      }}
                      options={BristolSeatNames}
                    />
                  )}
                  {SgpSeatNames.length > 0 && (
                    <CheckBoxGroup
                      value={this.state.selectedSgpSeatNames}
                      onChange={(event) => {
                        this.handleSGPChangeMultiple(event);
                        console.log("value: ", event.value);
                        console.log("option: ", event.option);
                        //setValue(event.value);
                      }}
                      options={SgpSeatNames}
                    />
                  )}
                </Box>
              </Box>
            )}
            <Box
              align="center"
              justify="center"
              direction="row"
              gap="large"
              margin="medium"
            >
              <Button
                label="Back"
                primary
                reverse
                icon={<Rewind />}
                onClick={this._handleback}
              />
              <Button
                label={
                  this.state.bShowEvtCreationOnDemandLoader ? (
                    <Box
                      direction="row"
                      gap="small"
                      justify="center"
                      align="center"
                    >
                      <Spinner size="small" color="brand" />{" "}
                      <Text>Creating demo event..</Text>
                    </Box>
                  ) : (
                    "Submit"
                  )
                }
                //active={false}
                primary
                reverse
                icon={<Console />}
                disabled={
                  this.state.bShowEvtCreationOnDemandLoader ||
                  isSubmitNotEnabled ||
                  !isPwdStrong
                }
                onClick={this._handleEventRequestSubmit}
              />
              {bTriggerLauching && (
                <Launchdemospinner
                  hide={this._HideLauncher}
                  IsFromScheduling={true}
                />
              )}
              {bSHowDupeWarning && <InfoWarning hide={this._hideInfoWarning} />}
            </Box>
          </Box>
        </Layer>
      </Main>
    );
  }
}

export default ScheduleDemoOverlayB;
